import { IAddress } from './IAddress';
import {IPlanName} from './IPlanName';

export class InsuranceCarriers {
    RowNumber:number;
    insuranceCarrierId: number;
    insuranceName: string;
    insuranceCode: string;
    insuranceAddress: string;
    addressId: number;
    isActive: boolean;
    createdBy: string;
    createdOn: Date;
    payerClass: string;
    payerType: string;
    url: string;
    institutionPayer: string;
    professionPayer: string;
    address1: string;
    address2: string;
    postalCode: string;
    phone: string;
    fax: string;
    emailId: string;
    cityName: string;
    stateName: string;
    zip : string;
    planeName:string;
    planIds:any;
    claimType?:string;
    insFullName:string
    addressDetails:IAddress;
    payerClassName:string;
    payerTypeName:string;
    professional:string;
    institutional:string;
    status:string;
    modifyBy:string;
    plans:IPlanName[];
    notes:string;
    PayerMapId:number;
    isProfessionPayer?:boolean;
    IsCustomPayer: boolean;
    ChcPayerId?:string;
    PayerId: string;
    EligibilityID: string;
    ClaimStatusID: string;
    MustSClaimsToCH: string;
    PayerState: string;
    ConnectivityAvailable: string;
    EnrolmentRequired: string;
    Claims: string;
    Remit: string;
    Eligibility: string;
    EligibilityEnrollment:boolean;
    ClaimsEnrollment:boolean;
    ClaimsStatusEnrollment:boolean;
    ERAEnrollment:boolean;
    CrossoverExpected:boolean;
    ClaimStatus: string;
    Attachments: string;
    AttachmentType: string;
    InsuranceNameWithClaim: string;
    claimTypeConfig:string;
    isFacilityEnrolled:boolean;
    IndustryPayerID: string;
    FacilityEnrollmentDate: Date;
    // Computed client-side by ActivepayersComponent.buildClaimsId() — institutionPayer/
    // professionPayer joined together, '' when the payer has neither set yet.
    claimsId?: string;
    attachmentTypeDisplay?: string;

}